import type { RequestConfig } from '@customTypes/index';

import { api } from '@/shared/api/instance';

type RegisterRequest = {
  requestId: string;
};

export type DeleteRegisterRequestParams = RequestConfig<RegisterRequest>;

export const deleteRegisterRequest = async ({
  params
}: DeleteRegisterRequestParams) =>
  api.delete(`/api/registrationrequests/${params.requestId}`);
